export default {
    name: 'ButtonCalendarSync'
}